// extracted by mini-css-extract-plugin
module.exports = {"wrap":"RouterProgress_wrap__Y8qBy","bar":"RouterProgress_bar__ty6gx"};